/* ==========================================================================
   Zimply Natural — Reorder Form Routing
   Mischungsnummer + optional name → /pages/nachbestellung?id=XXXX&name=YYY
   The destination page handles the actual lookup (Phase 2 / Thomas).
   For Phase 1: validates input format and redirects.
   ========================================================================== */

(function () {
  'use strict';

  var PATTERN = /^[A-Za-z0-9-]{4,16}$/;
  var DEFAULT_TARGET_PATH = '/pages/nachbestellung';

  function getErrorEl(form) {
    return form.querySelector('.zimply-reorder__error');
  }

  function showError(form, msg) {
    var el = getErrorEl(form);
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
  }

  function clearError(form) {
    var el = getErrorEl(form);
    if (!el) return;
    el.textContent = '';
    el.classList.remove('is-visible');
  }

  function handleSubmit(e) {
    var form = e.currentTarget;
    var mischungInput = form.querySelector('input[name="mischungsnummer"]');
    var nameInput = form.querySelector('input[name="name"]');
    if (!mischungInput) return;

    e.preventDefault();
    clearError(form);

    var mischung = mischungInput.value.trim().toUpperCase();
    var name = nameInput ? nameInput.value.trim() : '';

    if (!mischung) {
      showError(form, 'Bitte gib Deine Mischungsnummer ein.');
      mischungInput.focus();
      return;
    }

    if (!PATTERN.test(mischung)) {
      showError(
        form,
        'Die Mischungsnummer enthält ungültige Zeichen. Bitte prüfe Dein Etikett.'
      );
      mischungInput.focus();
      return;
    }

    if (nameInput && nameInput.required && !name) {
      showError(form, 'Bitte gib Deinen Vornamen ein.');
      nameInput.focus();
      return;
    }

    var target = (form.dataset.target || '').trim() || DEFAULT_TARGET_PATH;
    var params = new URLSearchParams();
    params.set('id', mischung);
    if (name) params.set('name', name);

    window.location.href = target + '?' + params.toString();
  }

  function init() {
    var forms = document.querySelectorAll('form.zimply-reorder-form');
    forms.forEach(function (form) {
      if (form.dataset.zimplyReorderBound === '1') return;
      form.dataset.zimplyReorderBound = '1';
      form.addEventListener('submit', handleSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
